import {Component} from '@angular/core';

@Component({
  selector: 'wg-hud-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.less'],
})
export class ChatComponent {

}
